<template>
  <section id="contact">
    <b-container class="text-center">
      <b-row>
        <b-col>
          <h1>Pitch Us</h1>
          <hr>
          <h3>Two ways to pitch your startup</h3>
        </b-col>
      </b-row>

      <b-row class="d-flex align-items-center">
        <b-col md="5" class="contact-left">
          <p>Check your eligibility for our seed program, the Tachi.ai 15 (see below).</p>
        </b-col>

        <b-col md="2" class="or">
          <p>OR</p>
        </b-col>

        <b-col md="5" class="contact-right">
          <p>Upload your pitch deck directly</p>
          <form action="contactform.php" method="post">
            <fieldset class="form-group">
              <label class="sr-only">Name</label>
              <input name="name" type="text" class="form-control" placeholder="Your name">
            </fieldset>
            <fieldset class="form-group">
              <label class="sr-only">Email</label>
              <input name="email" type="email" class="form-control" placeholder="Your email">
            </fieldset>
            <fieldset class="form-group">
              <label class="sr-only">File input</label>
              <input name="file" type="file" class="form-control-file" id="exampleFormControlFile1">
            </fieldset>
            <button name="submit" type="submit" class="btn btn-outline-info btn-block">Send</button>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
#contact {
  padding: 4.25rem 0;
}

#contact h3 {
  padding-bottom: 30px;
}

#contact .contact-right,
#contact .contact-left {
  background-color: #ff110036;
  padding: 30px;
  border-radius: 10px;
}

#contact .or {
  font-size: 2rem;
  font-weight: bold;
}

#contact hr {
  width: 20rem;
  height: 0.05rem;
  margin: 2rem auto 1rem;
}
</style>